module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-BoldItalic.aa839e4a.woff";